import React, { useEffect, useState } from "react";
import firebase from "../../config/firebase";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import PaymentConditionList from "./PaymentConditionList";
import { GlobalConfirmModal, GlobalSuccessModal } from "../../components/modalGlobal/modalGlobal";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function PaymentConditionPage() {
  const db = firebase.firestore();
  const user = useSelector((state) => state.user);
  const userLogado = useSelector((state) => state.usuarioLogado);

  const canViewPaymentCondition = user?.permissoes?.paymentCondition?.isView === true;
  const canDeletePaymentCondition = user?.permissoes?.paymentCondition?.isDelete === true;

  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedCondition, setSelectedCondition] = useState(null);
  const [openInfoDialog, setOpenInfoDialog] = useState(false);

  useEffect(() => {
    const unsubscribe = db
      .collection("paymentCondition")
      .orderBy("description")
      .onSnapshot(
        (snapshot) => {
          const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setConditions(data);
          setLoading(false);
        },
        (error) => {
          console.error("Erro ao buscar condicoes de pagamento:", error);
          setLoading(false);
        }
      );

    return () => unsubscribe();
  }, []);

  const handleOpenDelete = (condition) => {
    setSelectedCondition(condition);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedCondition?.id || !canDeletePaymentCondition) return;

    try {
      await db.collection("paymentCondition").doc(selectedCondition.id).delete();
      setOpenInfoDialog(true);
    } catch (error) {
      console.error("Erro ao excluir condicao de pagamento:", error);
    } finally {
      setOpenDeleteDialog(false);
      setSelectedCondition(null);
    }
  };

  if (userLogado <= 0) {
    return <Navigate to="/login" />;
  }

  if (!canViewPaymentCondition) {
    return <Navigate to="/" replace />;
  }

  return (
    <NewMiniDrawer
      divOpen={
        <>
          <PaymentConditionList
            conditions={conditions}
            loading={loading}
            openDeleteModal={handleOpenDelete}
          />

          <GlobalConfirmModal
            open={openDeleteDialog}
            handleClose={() => setOpenDeleteDialog(false)}
            handleConfirm={handleDeleteConfirm}
            title="Deseja mesmo excluir esta condição de pagamento?"
            subtitle={selectedCondition?.description ? `Condição: ${selectedCondition.description}` : "Esta ação não poderá ser desfeita."}
          />

          <GlobalSuccessModal
            open={openInfoDialog}
            handleClose={() => setOpenInfoDialog(false)}
            title="Condição de pagamento excluída com sucesso!"
          />
        </>
      }
    />
  );
}

export default PaymentConditionPage;
